/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default ({authGuard, guestGuard}) => [
  ...authGuard([
    {
      path: "",
      component: () => import("../layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          name: "dashboard",
          component: () => import("../views/Dashboard.vue"),
        },
      ],
    },
  ]),
  // Guest routes.
  ...guestGuard([
    {path: "*", redirect: {name: "login"}},
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Callback.vue"),
    },
    {
      path: "/callback",
      name: "auth-callback",
      component: () => import("@/views/Callback.vue"),
    },
  ])
]
